module.exports = __webpack_public_path__ + "img/a56c4950f89e92cdf1e7145fe9710e87.png";